// allow setting dark mode with url param for development testing
export const setDarkMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const darkMode =
    urlParams.get("dark-mode") || sessionStorage.getItem("darkMode");

  if (darkMode) sessionStorage.setItem("darkMode", darkMode);

  if (!["f", "false", "0", "", null].includes(darkMode)) {
    document.body?.classList.add("dark");
  }
};
